//import { UserService } from 'src/app/services/user.service';

import { Component, Input, SimpleChanges, OnInit, ChangeDetectorRef, ViewChild, AfterViewInit } from '@angular/core'
import { WizardComponent } from 'angular-archwizard';
import { MatDialog, MatSnackBar } from '@angular/material';


import { NgxSpinnerService } from 'ngx-spinner';

//Prueba NGRX STORE
import { Store } from '@ngrx/store';
import { Form } from 'src/app/models/form.model';
import { FilemakerService } from 'src/app/services/filemaker.service';
import { CertificadosService } from 'src/app/services/certificados.service';
import { Tipo_propiedadComponent } from '../../formulario/tipo_propiedad/tipo_propiedad.component';
import { CipComponent } from '../../formulario/cip/cip.component';

interface AppState {
  form: Form;
}

@Component({
    selector: "msw-navbar_cert",
    templateUrl: "./navbar_cert.component.html",
    styleUrls: ["./navbar_cert.component.css"],
    providers: [ FilemakerService, CertificadosService]
})

export class Navbar_certComponent implements OnInit {
    @Input() form: Form;
    @Input() title: Form;
    tabs = [];
    actualForm = [];
    tempForm;
    @ViewChild('wizard') wizard: WizardComponent;
    wizardSteps: Array<Object>;
    tempWizard = []; 
    start = 0;
    end = 0;
    limit = 4;
    actual = 0;
    data = [];
   // borradorId;
    //infoBorrador;
    //formulariofinal;
    items = [
      {
        name: 'Prueba 1',
        component: Tipo_propiedadComponent
      },
      {
        name: 'Prueba 2',
        component: CipComponent
      }
    ];
    constructor(private _certService:CertificadosService,
                private _changeDetectionRef: ChangeDetectorRef,
                private dialog: MatDialog, private store: Store<AppState>,
                private spinner: NgxSpinnerService, 
                private snackBar: MatSnackBar, private filemaker: FilemakerService){
                  
                this.wizardSteps = [ ];
    }
    
    ngOnInit(){
     
    }
    ngDoCheck(){
      this._changeDetectionRef.detectChanges();

    }

    ngOnChanges(changes: SimpleChanges){
      for (let propName in changes) {  
        var change = changes[propName];
        var curVal  = JSON.stringify(change.currentValue);
        var prevVal = JSON.stringify(change.previousValue);
      }
      this.getPasos(this.form)
           //this.borradorId = sessionStorage.getItem("borrador");
     } 

    getPasos(id){
      this.spinner.show()
      this.wizardSteps = [];
      this.data = [];
      this.actual = 0;
      this.start = 0;
      this.end = 0;
      this.limit = 4;
      this._certService.getPasos().subscribe(
          response => {
            console.log(JSON.stringify(response))
              for(let x = 0; x < response.forms.length;x++){
                  if(response.forms[x].name == id){
                      console.log(response.forms[x])
                      let promise = new Promise((resolve, reject) => {
                        for(let t = 0; t < response.forms[x].tabs.length; t++){
                          this.wizardSteps.push(response.forms[x].tabs[t])

                      }
                      resolve(this.wizardSteps)
                      })

                      promise.then(() => {
                        for (let i = 0; i < 4; i++) {
                          this.data.push(this.wizardSteps[i]);
                        }
                    
                        this.start = 0;
                        this.end = this.start + this.limit;

                      })
                 }
              }
              this.spinner.hide();
          },
          error => {
              console.log("Error", error)
              this.spinner.hide();
          }
      )
  }
    next() {
        if (this.actual+1 == this.wizardSteps.length) {
          return;
        }
        this.actual++;
        if(this.actual == this.end-1 && this.actual != this.wizardSteps.length-1){
          this.data.push(this.wizardSteps[this.actual+1]);
          this.data.splice(0,1);
          this.end++;
          this.start++;
        }
    
      }
    
      back() {
        if (this.actual == 0 && this.start == 0) {
          return;
        }
    
        this.actual--;
    
        if(this.actual == this.start && this.start > 0){
          this.data.unshift(this.wizardSteps[this.start-1]);
          this.data.splice(this.data.length-1,1)
          this.end--;
          this.start--;
        }
      }

      /*saveDraft(){
        this.dialog.open(crearBorradorComponent)
      }

      updateDraft(){
        this.infoBorrador = this.allStorage();
        this._certService.updateDraft(this.borradorId, this.infoBorrador).subscribe(
          response => {
            if(response.update){
              this.snackBar.open(response.message, 'Cerrar',{
                duration: 3000
              })
            } else {
              this.snackBar.open(response.message, 'Cerrar',{
                duration: 3000
              })
            }
          },
          error => {
            console.log(error)
          }
        )
      }

      allStorage() {

        return Object.keys(localStorage)
        .reduce((obj, k) => {
            return { ...obj, [k]: JSON.parse(localStorage.getItem(k))}}, {});
      }

      guardar_expediente(){
        this.formulariofinal = this.allStorage();
        this.filemaker.guardarExpediente(this.formulariofinal).subscribe(
          response =>{
            console.log(response)
          },
          error =>{
            console.log(error)
          }
        )
      }*/
}